export var isEmpty = function isEmpty(node) {
  var _node$content;
  return !(node !== null && node !== void 0 && (_node$content = node.content) !== null && _node$content !== void 0 && _node$content.length);
};